










import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import RemoveConnection from '@/components/modals/RemoveConnection.vue';

declare var $: any;

@Component({
    components: {
        RemoveConnection
    },
    computed: mapState(['modalActive', 'modalMode']),
    watch: {
        modalActive(value: string) {
            const $modal = $('#modal');

            if (value) {
                $modal.modal('show');
            } else {
                $modal.modal('hide');
            }
        }
    }
})
export default class Modal extends Vue {
    mounted() {
        const $modal = $('#modal');

        $modal.on('hidden.bs.modal', () => {
            const { commit } = this.$store;

            commit('setModalMode', '');
            commit('setModalData', {});
            commit('closeModal');
        });
    }
}
